import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

export const LandingFaq = ({ faqs = [] }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  if (!faqs || faqs.length === 0) return null;

  return (
    <section className="py-5" style={{ backgroundColor: '#ffffff' }}>
      <div className="container" style={{ maxWidth: '720px' }}>
        <div className="text-center mb-4">
          <span className="badge rounded-pill mb-2 px-3 py-2" style={{ backgroundColor: 'rgba(14, 171, 176, 0.12)', color: 'var(--bry-accent, #0EABB0)', border: '1px solid var(--bry-accent, #0EABB0)' }}>
            Dudas comunes
          </span>
          <h2 className="text-dark fw-bold">Preguntas Frecuentes</h2>
        </div>

        <div className="d-flex flex-column gap-3">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="rounded-3 p-3 transition-all shadow-sm"
                style={{
                  backgroundColor: '#ffffff',
                  border: isOpen ? '1.5px solid var(--bry-accent, #0EABB0)' : '1px solid #e2e8f0',
                  cursor: 'pointer'
                }}
                onClick={() => toggleFaq(idx)}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <h6 className="text-dark fw-semibold mb-0" style={{ fontSize: '0.98rem' }}>
                    {faq.q}
                  </h6>
                  <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>
                    <FontAwesomeIcon icon={faChevronDown} style={{ color: 'var(--bry-accent, #0EABB0)' }} />
                  </motion.div>
                </div>

                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <p className="text-secondary small mt-3 mb-0 pt-2 border-top border-secondary border-opacity-25" style={{ lineHeight: 1.5 }}>
                        {faq.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LandingFaq;
